export enum AssetCurrencyExchangeRequestStatus {
  New = 'new',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Revoked = 'revoked',
}
